/**
 * Matomo custom dimension indices — must match Admin → Custom Dimensions in Matomo.
 * @see docs/features/1.5.0/matomo-tracking/README.md
 */
export const ANALYTICS_DIMENSIONS = {
  permissionGroups: 1
} as const;

export type AnalyticsDimensionId = (typeof ANALYTICS_DIMENSIONS)[keyof typeof ANALYTICS_DIMENSIONS];
